import { Pipe, PipeTransform } from "@angular/core";

import { Model } from "../model/model";

@Pipe({
    name: 'searchModels'
})

export class SearchModelsPipe implements PipeTransform {

    transform(value: Array<Model>, searchTerm: string) {
        if (searchTerm) {
            let filtered: Array<Model> = value.filter(x => {
                return x.ModelDescription.toLowerCase().includes(searchTerm.toLowerCase()) || x.ModelNumber.toLowerCase().includes(searchTerm.toLowerCase())
            });
            if (filtered.length === 0) { return [{ empty: true, message: 'No Matches Found.' }] }
            return filtered;
        } else {
            return value;
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/pipes/models-search.pipe.ts